import _ from 'lodash'
import Axios from 'axios'

// var Config = require('./../../config/js')

const FORBIDDEN = 403
const LOGIN_PATH = '/api-auth/login/'

/*
const buildAPIURL = () => {
  const endpointsByEnv = {
    dev: Config.dev.env.API_ROOT,
    staging: Config.staging.env.API_ROOT,
    prod: Config.build.env.API_ROOT
  }

  console.log({endpointsByEnv})

  let API_BASE_URL

  if (process.env.NODE_ENV === 'development') {
    API_BASE_URL = endpointsByEnv.dev
  }

  if (process.env.NODE_ENV === 'staging') {
    API_BASE_URL = endpointsByEnv.staging
  }

  if (process.env.NODE_ENV === 'production') {
    API_BASE_URL = endpointsByEnv.prod
  }

  var cleanApiUrl = API_BASE_URL.split('"')[1]

  return cleanApiUrl
}
*/

let buildAPIURL = () => {
  return '/api/'
}

const axiosBase = Axios.create({
  baseURL: buildAPIURL()
})

const onSuccess = _.identity
const onFailure = (error) => {
  if (error.response.status === FORBIDDEN) {
    window.location.href = LOGIN_PATH
  }
}

axiosBase.interceptors.response.use(
  onSuccess,
  onFailure
)

export {
  axiosBase
}



// WEBPACK FOOTER //
// ./uncommon-client/api/config.js